export const settings = {
  languages: [
    { label: "ENGLISH", value: "en" },
  ],
  displaySocial: true,
  site: {
    name: 'Laguna-Beach',
    address: '381 Forest Avenue, Laguna Beach, CA 92651',
    phone: '9494979229',
    map: 'https://maps.app.goo.gl/ZmDqg164SMT8XP2y5',
    latitude: 33.5435656,
    longitude: -117.7820089,
    website:'https://www.visitlagunabeach.com/',
    privacyLink:'https://www.visitlagunabeach.com/privacy-policy/',
    twitter:'https://twitter.com/visitlaguna',
    facebook: 'https://www.facebook.com/visitlaguna',
    pinterest:'',
    instagram:'https://www.instagram.com/visitlaguna/',
    youtube:'https://www.youtube.com/user/VisitLagunaBeach',
    splashImage: '../themes/Laguna-Beach/assets/splashscreens/bg_img.png',
    homeEvents: false
  },
  organizations: [
    {
      logo: '',
      website: 'https://www.visitlagunabeach.com/',
      phone: '9494979229',
      location: 'https://maps.app.goo.gl/ZmDqg164SMT8XP2y5',
      latitude: 33.5435656,
      longitude: -117.7820089,
      address: '381 Forest Avenue, Laguna Beach, CA 92651',
    }
  ],

  debug: true
};
